export default "__VITE_ASSET__DgEo53Re__"